module.exports = __webpack_public_path__ + "static/ari-mir-44b6e019cb934e87a0e558efc7de6e33.png";